import { render, staticRenderFns } from "./InvestmentCompleted.vue?vue&type=template&id=e6af0c7e&scoped=true"
import script from "./InvestmentCompleted.vue?vue&type=script&lang=ts"
export * from "./InvestmentCompleted.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentCompleted.vue?vue&type=style&index=0&id=e6af0c7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6af0c7e",
  null
  
)

export default component.exports